export const reservationInvoicePanel = {
  loadingVerifying: "Wird überprüft…",

  status: {
    draft: "Entwurf",
    sent: "Ausgestellt",
    processing: "In Bearbeitung",
    pending: "Ausstehend",
    error: "Fehler",
    corrected: "Berichtigt",
    voided: "Storniert",
  },

  common: {
    cancel: "Abbrechen",
    understood: "Verstanden",
    optional: "optional",
    optionalParen: "(optional)",
    sending: "Wird gesendet…",
    saving: "Wird gespeichert…",
    deleting: "Wird gelöscht…",
    emitting: "Wird ausgestellt…",
    creating: "Wird erstellt…",
    retrying: "Neuer Versuch…",
  },

  issued: {
    title: "Ausgestellte Rechnungen",
    rectifOf: "Berichtigung von {code}",
    viewPdf: "PDF ansehen",
    sendByWhatsapp: "Per WhatsApp senden",
    correctTitle: "Berichtigen (Berichtigungsrechnung)",
    voidTitle: "Stornieren (Korrekturrechnung)",
  },

  empty: {
    guestRequested: "Der Gast hat seine Rechnung angefordert",
    noInvoice: "Keine Rechnung ausgestellt",
    linkSent: "Link gesendet",
    requested: "Angefordert",
    requestedSub: "Prüfen Sie seine Daten und stellen Sie die Rechnung aus, oder senden Sie ihm den Link zur Bestätigung.",
    sub: "Senden Sie dem Gast den Link oder erstellen Sie die Rechnung direkt.",
    copyLinkTitle: "Link in die Zwischenablage kopieren",
    sendLink: "Link senden",
    createInvoice: "Rechnung erstellen",
    configureHint: "Hinterlegen Sie Ihre Rechnungsdaten, um diese Funktion freizuschalten.",
  },

  next: {
    title: "Für diese Buchung liegt bereits die Rechnung vor",
    sub: "Kam später noch etwas dazu? Erstellen Sie eine weitere Rechnung für diese Buchung: Sie enthält nur die neuen Positionen (die bereits abgerechnete Unterkunft wird nicht wiederholt).",
    button: "Weitere Rechnung für diese Buchung erstellen",
  },

  card: {
    draftRefTitle: "Interne Referenz des Entwurfs. Die steuerliche Nummer wird beim Ausstellen vergeben.",
  },

  draft: {
    emptyHint: 'Fügen Sie unter <b>„Neue Positionen“</b> mindestens eine Position hinzu, um diese Rechnung auszustellen.',
    noteLead: "Entwurf: Bearbeiten Sie die Daten oder fügen Sie oben Positionen hinzu; Nummer und Datum werden beim <b>Ausstellen</b> vergeben.",
    nextSequential: "Nächste fortlaufende Nummer",
    estimated: "geschätzt",
    noteFoot: "Die Nummer ist noch nicht endgültig: Wer zuerst ausstellt, bekommt sie.",
    confirmEmit: "Bestätigen und Rechnung ausstellen",
    previewPdf: "PDF-Vorschau",
    sendQuote: "Angebot senden",
    edit: "Rechnung bearbeiten",
    discard: "Verwerfen",
  },

  // Positionen des laufenden Dokuments: was VOR dem Ausstellen geprüft wird.
  concepts: {
    title: "Positionen des Dokuments",
    item: "Position",
    qty: "Menge",
    unitPrice: "Einzelpreis",
    vat: "MwSt.",
    amount: "Betrag",
    linesTotal: "Summe der Positionen",
    foot: "So erscheint die Aufschlüsselung auf der Rechnung. Das PDF enthält alle Details.",
    mismatch: "Die Summe der Positionen ({lines}) stimmt nicht mit der Gesamtsumme des Dokuments ({total}) überein. Prüfen Sie das vor dem Ausstellen.",
  },

  // Lo cobrado y lo que queda a deber. Mismas palabras y mismo orden que el
  // pie del PDF, para que leer la pantalla y leer la factura sea lo mismo.
  cobro: {
    total: "Gesamtbetrag des Belegs",
    nothing: "Keine Zahlungen erfasst",
    due: "Offener Betrag",
    assumed: "Für diese Buchung sind keine Zahlungen erfasst. Der Betrag gilt anhand der gewählten Zahlungsart als bezahlt, und im PDF steht dasselbe. Wenn noch nicht gezahlt wurde, erfassen Sie die Zahlung oder ändern Sie die Zahlungsart.",
  },

  actions: {
    sendWhatsapp: "WhatsApp senden",
    correct: "Berichtigen",
    void: "Stornieren",
    refresh: "Aktualisieren",
    retry: "Erneut versuchen",
    editData: "Daten bearbeiten",
    delete: "Löschen",
  },

  wa: {
    title: "Rechnung per WhatsApp senden",
    desc: "Die Rechnung <strong>{code}</strong> wird dem Gast als PDF über WhatsApp gesendet.",
    issuedFallback: "ausgestellt",
    checkPhone: "Verwendet wird die mit der Buchung verknüpfte Telefonnummer des Gastes",
    checkPdf: "Das Dokument wird als PDF gesendet",
    send: "Rechnung senden",
  },

  sendLink: {
    title: "Rechnungslink senden",
    desc: "Der Gast erhält einen <strong>WhatsApp-Link</strong>, um seine Steuerdaten zu bestätigen und seine Rechnung herunterzuladen.",
    checkNoInvoice: "Es wird noch keine Rechnung ausgestellt: Der Gast erhält nur den Link",
    button: "Link senden",
  },

  retryModal: {
    title: "Ausstellen erneut versuchen",
    desc: "Wir versuchen erneut, <strong>diese Rechnung auszustellen</strong>, mit den aktuellen Daten.",
    check1: "Sie wird erneut an die Behörde für die elektronische Rechnung gesendet",
    check2: "Bei Erfolg wird die endgültige steuerliche Nummer vergeben",
  },

  voidModal: {
    doneTitle: "Rechnung storniert · Korrekturrechnung ausgestellt",
    creditNoteIssued: "Korrekturrechnung <strong>{code}</strong> ausgestellt",
    chargesReleased: "Die zusätzlichen Positionen wurden freigegeben",
    clientCanRequest: "Der Kunde kann die Rechnung erneut anfordern",
    doneHint: "Fügen Sie die offenen Positionen hinzu oder korrigieren Sie sie und erstellen Sie eine neue Rechnung.",
    formTitle: "Rechnung stornieren / Korrekturrechnung ausstellen",
    formDesc: "Nutzen Sie diese Option, wenn Sie <strong>Leistungen oder Beträge ergänzen oder ändern</strong> müssen. Es wird eine <strong>Korrekturrechnung</strong> ausgestellt, die die ursprüngliche Rechnung storniert, und Sie können anschließend eine neue Rechnung mit den richtigen Positionen erstellen.",
    stepAnnul: "Es wird eine steuerliche Korrekturrechnung ausgestellt, die {code} storniert",
    stepFree: "Die Positionen werden zum Ergänzen oder Korrigieren freigegeben",
    stepNewNumber: "Es wird eine neue Rechnung mit der nächsten Nummer erstellt",
    notice: "Um nur die Steuernummer, den Namen oder die Adresse ohne Änderung der Beträge zu korrigieren, nutzen Sie stattdessen <strong>Daten berichtigen</strong>.",
    voiding: "Korrekturrechnung wird ausgestellt…",
    confirm: "Stornieren und Korrekturrechnung ausstellen",
  },

  edit: {
    titleDraft: "Rechnung bearbeiten",
    titleClient: "Kundendaten bearbeiten",
    descDraft: "Änderungen werden sofort gespeichert. Die Steuerdaten werden geprüft, ohne auszustellen.",
    descSent: "Beim Speichern wird der Versand automatisch erneut versucht.",
    type: "Typ",
    individual: "Privatperson",
    individualSub: "Natürliche Person",
    company: "Unternehmen",
    companySub: "Juristische Person",
    legalName: "Firmenname",
    fullName: "Vollständiger Name",
    legalNamePlaceholder: "Firmenname des Unternehmens",
    fullNamePlaceholder: "Vor- und Nachname",
    country: "Land",
    countryPlaceholder: "Land des Gastes auswählen",
    taxRequiredOnEmit: "beim Ausstellen erforderlich",
    taxIdPlaceholderCompany: "NIF / CIF des Unternehmens",
    taxIdPlaceholderIndividual: "DNI / NIE · leer = Endverbraucher",
    email: "E-Mail",
    emailPlaceholder: "email@beispiel.com",
    phone: "Telefon",
    phonePlaceholder: "+34 600 000 000",
    fiscalAddress: "Steueranschrift",
    addressPlaceholder: "Straße und Hausnummer",
    city: "Stadt",
    region: "Region / Provinz",
    zip: "Postleitzahl",
    saveChanges: "Änderungen speichern",
    saveAndRetry: "Speichern und erneut versuchen",
  },

  deleteModal: {
    title: "Rechnung löschen",
    desc: "Dieser Rechnungsversuch wird gelöscht. Der Kunde kann die Rechnung von Neuem anfordern.",
    noticeIrreversible: "Diese Aktion kann nicht rückgängig gemacht werden.",
  },

  emit: {
    title: "Bestätigen und Rechnung ausstellen",
    subtitle: "Sie wird offiziell erfasst",
    desc: "Sie sind dabei, die Rechnung für {name} auszustellen.",
    stepNumberEstimate: "Sie erhält die fortlaufende Nummer <b>{code}</b>: Wer zuerst ausstellt, bekommt sie.",
    stepNumberFinal: "Sie erhält die <b>endgültige</b> fortlaufende Nummer: Wer zuerst ausstellt, bekommt sie.",
    stepPdf: "Das steuerliche PDF wird erstellt und bei der Steuerbehörde eingereicht.",
    warn: "Einmal ausgestellt, <b>lässt sie sich nicht mehr bearbeiten</b>. Bei einem Fehler müssen Sie sie <b>stornieren und eine neue Rechnung erstellen</b> (Korrekturrechnung oder Berichtigung).",
    confirm: "Bestätigen und ausstellen",
  },

  newInvoice: {
    title: "Weitere Rechnung erstellen",
    subtitle: "Für dieselbe Buchung",
    desc: "Es wird ein <strong>neuer Entwurf</strong> für diese Buchung geöffnet.",
    step1: "Er enthält <b>nur die neuen Positionen</b>, die Sie hinzufügen: Die bereits abgerechnete Unterkunft wird nicht wiederholt.",
    step2: "Er übernimmt die Daten desselben Kunden. Die Nummer wird beim Ausstellen vergeben.",
    createDraft: "Entwurf erstellen",

    // Facturar toda la reserva o una sola habitación (reservas de varias).
    scopeTitle: "Wie möchten Sie abrechnen?",
    whole: "Die ganze Buchung",
    wholeHint: "Eine einzige Rechnung mit {n} Zimmern.",
    perRoom: "Ein Zimmer",
    perRoomHint: "Jedes Zimmer seine eigene Rechnung. Wenn jeder Gast seinen Teil zahlt.",
    pickRoom: "Zimmer auswählen",
    roomLodging: "Unterkunft",
    alreadyInvoiced: "bereits abgerechnet",
  },

  correction: {
    doneTitle: "Berichtigung ausgestellt",
    createdOk: "Berichtigung <strong>{code}</strong> erfolgreich erstellt",
    originalKept: "Die ursprüngliche Rechnung bleibt als steuerliche Referenz erhalten (sie wird nicht gelöscht)",
    pdfSoon: "Das PDF wird in Kürze erstellt",
    title: "Rechnung berichtigen",
    infobox: "Es wird eine <strong>berichtigende Korrekturrechnung</strong> ausgestellt, die <strong>{code}</strong> steuerlich ersetzt und die aktuellen Positionen der Buchung enthält. Die ursprüngliche Nummer lässt sich nicht ändern (gesetzliche Vorgabe).",
    reasonLabel: "Grund für die Berichtigung",
    selectReason: "Grund auswählen",
    reasonTaxId: "Falsche NIF / CIF oder Steuernummer",
    reasonName: "Falscher Name oder Firmenname",
    reasonAddress: "Falsche Steueranschrift",
    reasonEmail: "Falsche E-Mail-Adresse",
    reasonGeneral: "Allgemeine Berichtigung der Steuerdaten",
    reasonOther: "Anderer Grund (bitte angeben)",
    customReasonPlaceholder: "Beschreiben Sie den Grund für die Berichtigung…",
    recipientDivider: "Daten des Empfängers · ändern Sie nur, was Sie berichtigen müssen",
    nameOrLegalName: "Name / Firmenname",
    taxIdFull: "NIF / CIF / Steuernummer / Reisepass",
    countryTwoLetters: "(2 Buchstaben)",
    paymentDivider: "Zahlungsart",
    paymentLabel: "Zahlungsart",
    paymentUnspecified: "Nicht angegeben",
    paymentCash: "Bar",
    paymentCard: "Kredit- / Debitkarte",
    paymentTransfer: "Banküberweisung",
    paymentStripe: "Stripe (online)",
    emitRectif: "Berichtigung ausstellen",
  },

  request: {
    typeCompany: "Unternehmen",
    typeIndividual: "Privatperson",
    type: "Typ",
    legalName: "Firmenname / Name",
    taxId: "NIF / CIF",
    address: "Adresse",
    postalCode: "Postleitzahl",
    city: "Stadt",
    state: "Provinz",
    country: "Land",
    email: "E-Mail",
  },

  toast: {
    linkSent: "Rechnungslink per WhatsApp an den Gast gesendet.",
    alreadyIssued: "Für diese Buchung wurde bereits eine Rechnung ausgestellt.",
    cantSendLink: "Der Link konnte nicht gesendet werden.",
    linkCopied: "Link in die Zwischenablage kopiert.",
    alreadyHasInvoice: "Für diese Buchung liegt bereits eine Rechnung vor.",
    cantGenerateLink: "Der Link konnte nicht erstellt werden.",
    cantSendWhatsapp: "Der Versand über WhatsApp war nicht möglich.",
    invoiceSentWhatsapp: "Rechnung per WhatsApp gesendet.",
    draftCreatedNewCharges: "Entwurf mit den neuen Positionen erstellt (ohne die Unterkunft zu wiederholen). Prüfen Sie ihn und stellen Sie ihn aus.",
    draftCreated: "Entwurf erstellt. Fügen Sie Positionen hinzu und stellen Sie ihn aus, wenn er fertig ist.",
    alreadyInProgress: "Für diese Buchung ist bereits eine Rechnung in Arbeit.",
    cantCreateDraft: "Der Entwurf konnte nicht erstellt werden.",
    invoiceEmitted: "Rechnung ausgestellt. Nummer und PDF werden erstellt…",
    cantEmit: "Die Rechnung konnte nicht ausgestellt werden.",
    cantPreview: "Die Vorschau konnte nicht erstellt werden.",
    quoteSent: "Angebot an {email} gesendet",
    cantSendQuote: "Angebot konnte nicht gesendet werden",
    cantSync: "Der Status konnte nicht synchronisiert werden.",
    retrying: "Ausstellen wird erneut versucht…",
    cantRetry: "Erneuter Versuch nicht möglich.",
    cantVoid: "Fehler beim Stornieren der Rechnung.",
    savedCheckFiscal: "Gespeichert. Prüfen Sie das Steuerdokument.",
    dataUpdated: "Daten aktualisiert.",
    cantSaveData: "Die Daten konnten nicht gespeichert werden.",
    invoiceDeleted: "Rechnung gelöscht.",
    cantDelete: "Löschen nicht möglich.",
    cantEmitRectif: "Fehler beim Ausstellen der Berichtigung.",
  },
};
